import { originUrl } from "../../Scripts/Utils";
import { getLogoUrlByCode } from "@personalLoan/Scripts/LogoUrlService.js";
export default {
  methods: {
    originUrl: originUrl,
    logoSrc: function logoSrc(company) {
      var _getLogoUrlByCode;
      var staticUrl = ["CSOB", "MPSS", "UCB"].includes(company.uniqueShortcut) ? "/Imgs/".concat(company.uniqueShortcut, ".png") : "/Imgs/".concat(company.uniqueShortcut, ".svg");
      if (this.sources !== "su") return staticUrl;
      // SÚ companies are PersonalLoan partners: `code` is the partner code the logo endpoint looks up.
      return (_getLogoUrlByCode = getLogoUrlByCode(company.code, "".concat(originUrl(), "PersonalLoan/cz/"))) !== null && _getLogoUrlByCode !== void 0 ? _getLogoUrlByCode : staticUrl;
    },
    linkCompany: function linkCompany(company) {
      if (this.sources === 'mortgage') {
        return "".concat(originUrl(), "Partner/").concat(company.uniqueShortcut);
      } else if (this.sources === 'building') {
        switch (company.uniqueShortcut) {
          case 'RSTS':
            company.id = 1;
            break;
          case 'SSCS':
            company.id = 2;
            break;
          case 'MPSS':
            company.id = 4;
            break;
          default:
            company.id = 0;
        }
        return "".concat(originUrl(), "UnsecuredLoans/cz/Partner/").concat(company.id);
      } else {
        return "".concat(originUrl(), "PersonalLoan/cz/Partner/Detail/").concat(company.id);
      }
    }
  },
  props: {
    title: String,
    sources: String,
    externalBaseUrl: String,
    companies: null,
    locale: String
  },
  data: function data() {
    return {};
  },
  computed: {
    getCompanies: function getCompanies() {
      return this.companies.filter(function (company) {
        return company.name !== 'MONETA';
      }).filter(function (company) {
        return company.name !== 'MMBSS';
      }).filter(function (company) {
        return company.name !== 'MMB';
      }).map(function (company) {
        if (!company.uniqueShortcut) {
          company.uniqueShortcut = company.name;
          if (company.uniqueShortcut === 'MONETA') company.uniqueShortcut = 'MMB';else if (company.uniqueShortcut === 'UniCredit Bank') company.uniqueShortcut = 'UCB';else if (company.uniqueShortcut === 'Raiffeisenbank') company.uniqueShortcut = 'RB';else if (company.uniqueShortcut === 'Československá obchodní banka') company.uniqueShortcut = 'CSOB';else if (company.uniqueShortcut === 'Komerční banka') company.uniqueShortcut = 'KB';
        }
        return company;
      }).sort(function (a, b) {
        return (a.code || a.uniqueShortcut || "").toLowerCase().localeCompare((b.code || b.uniqueShortcut || "").toLowerCase());
      });
    }
  },
  mounted: function mounted() {}
};